import type { AppAction } from 'actions/types/ActionTypes'
import { generateLuxPlusSubscriptionItems } from 'lib/checkout/luxPlusSubscription/cart'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import { addToCartGTM } from 'analytics/eventDefinitions'
import { addToCheckoutCart } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { getBaseTierOfferWithJoiningFee, getBaseTierOfferWithNoJoiningFee, getRenewalOffer } from 'selectors/luxPlusSelectors'
import { getLuxPlusWaiveJoiningFeeOverride } from 'luxPlus/selectors/joiningFeeOverride'

interface PurchaseLuxPlus {
  hasJoinFee: boolean
  replaceCurrentWith?: string
}

function purchaseLuxPlus({ hasJoinFee, replaceCurrentWith }: PurchaseLuxPlus): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const currency = state.geo.currentCurrency
    const isLuxPlusMember = getCanRedeemLuxPlusBenefits(state)

    if (isLuxPlusMember) {
      return
    }

    const waiveJoiningFeeOverride = getLuxPlusWaiveJoiningFeeOverride(state)
    const effectiveHasJoinFee = hasJoinFee && !waiveJoiningFeeOverride

    let offer = effectiveHasJoinFee ? getBaseTierOfferWithJoiningFee(state) : getBaseTierOfferWithNoJoiningFee(state)
    let isRenewal = false

    // A renew-eligible member (resolved currentRenewalOffer) always renews onto their locked-in offer —
    // regardless of the CTA's `hasJoinFee`. This covers in-grace members who turned auto-renewal off and
    // land on the non-member "Become a member" CTA: they keep their grandfathered price and skip the
    // join fee, never the new-member offer. Genuine non-members have no renewal offer and fall through.
    const renewal = getRenewalOffer(state)
    if (renewal.offer) {
      offer = renewal.offer
      isRenewal = renewal.isRenewal
    }

    if (!offer) return

    const cartItems = generateLuxPlusSubscriptionItems(offer, isRenewal)
    const totalAmount = offer.price + (isRenewal || offer.joinFeeWaived ? 0 : offer.joinFee)
    fireEcommerceGTMEvent(addToCartGTM(offer, currency, totalAmount, undefined, 'subscription'))

    dispatch(addToCheckoutCart(cartItems))
    dispatch(navigateToCheckout({ replaceCurrentWith }))
  }
}

export default purchaseLuxPlus
